import React, { Component } from 'react'
import uuid from 'uuid/v1'
import { Row, Col } from 'reactstrap'

class ImageThumbnails extends Component {
  render() {
    const { filteredImages, activeImage, selectImage } = this.props

    return (
      <Row>
        {filteredImages && filteredImages.map(image =>
          <Col xs='6' sm='4' md='3' key={uuid()}>
            <img 
              className={`img-fluid m2clickable ${image.id === activeImage ? 'border border-primary' : ''}`}
              src={image.url}
              alt='image preview'
              onClick={() => selectImage(image.id)}
            />
            <p style={{wordBreak: 'break-all'}}>{image.name}</p>
          </Col>
        )}
      </Row>
    )
  }
}

export default ImageThumbnails


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/ImageThumbnails.js